import basicInfo from './infoFrom/basicInfo';
import codeInfo from './infoFrom/codeConfiguration';
import contents from './infoFrom/content';
import planList from './infoFrom/planList';
import configurationTemplate from './infoFrom/configurationTemplate.vue';
import { customerInsuranceDetail } from './request';
export default {
  components: {
    basicInfo,
    codeInfo,
    contents,
    planList,
    configurationTemplate
  },
  data() {
    return {
      activeKey: 1,
      customerInsuranceId: this.$route.params.id,
      disabled: false,
      insuranceId: this.$route.params.insuranceId,
      mark: '',
      customerId: '',
      productName: '',
      applicationId: ''
    };
  },
  created() {
    if (this.customerInsuranceId != -1) {
      customerInsuranceDetail({
        customerInsuranceId: this.customerInsuranceId
      }).then(res => {
        this.disabled = res.isGenerateQr ? false : true;
        this.mark = res.insuranceMark;
        this.customerId = res.customerId;
      });
    }
  },
  methods: {
    tabChange(val) {
      if (this.$route.params.id == -1) {
        return false;
      }
      this.activeKey = val;
    },
    previousFun() {
      if (this.disabled) {
        this.activeKey = 1;
      } else {
        this.activeKey = 2;
      }
    },
    async nextFun(val) {
      if (val.customerInsuranceId) {
        this.customerInsuranceId = val.customerInsuranceId;
      }
      if (this.activeKey == 1) {
        const {
          isGenerateQr,
          insuranceId,
          insuranceMark,
          customerId,
          name,
          applicationId
        } = await customerInsuranceDetail({
          customerInsuranceId: this.customerInsuranceId
        });
        this.insuranceId = insuranceId;
        this.mark = insuranceMark;
        this.productName = name.name;
        this.activeKey = isGenerateQr ? 2 : 3;
        this.disabled = isGenerateQr ? false : true;
        this.customerId = customerId;
        this.applicationId = applicationId;
      } else {
        this.activeKey++;
      }
    }
  }
};